import * as React from 'react';
import { connect } from 'react-redux';
import { IBasePageProps } from '../../configuration/IConfiguration';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../../../app';
import ContentContainer from '../../../Content/ContentContainer';
import * as AdminActionCreators from "../../../../actions/admin.actions";
import * as DTOS from "../../../../FeralScan.dtos";
import { Link } from 'react-router-dom';
import moment = require('moment');
import { LocalForm, Control } from 'react-redux-form';
import * as queryString from 'query-string';
import PaginatedTable, { ISortOption } from '../../../Data/PaginatedTable/PaginatedTable';
import { UserSortBy, sortUsers } from '../../../../helpers/graphHelper';
import withSortByQuery from '../../../Data/PaginatedTable/withSortByQuery';

type PageAdminUsersProps = {

}

type PageAdminUsersActions = {
}

type PageAdminUsersRouteParams = {
}

type PageAdminUsersQueryParams = {
    search: string;
}

type PageAdminUsersPropsMapped = {
    users: DTOS.User[];
    usersLoading: boolean;
}

type PageAdminUsersActionsMapped = {
    searchUsers: typeof AdminActionCreators.searchUsersRequest;
}

type PageAdminUsersAllPropsInherited = PageAdminUsersProps & PageAdminUsersActions;
type PageAdminUsersAllPropsMapped = PageAdminUsersPropsMapped & PageAdminUsersActionsMapped;

type PageAdminUsersAllProps = IBasePageProps<PageAdminUsersRouteParams, PageAdminUsersQueryParams> & Partial<PageAdminUsersAllPropsMapped> & PageAdminUsersAllPropsInherited;

class PageAdminUsers extends React.Component<PageAdminUsersAllProps, any> {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        this.props.searchUsers(this.props.queryParams.search, undefined);
    }

    componentDidUpdate(prevProps: PageAdminUsersAllProps) {
        if (prevProps.queryParams.search != this.props.queryParams.search) {
            this.props.searchUsers(this.props.queryParams.search, false);
        }
    }

    updateQuery(search: { searchText: string }) {
        var currentQueryString = queryString.parse(this.props.location.search);

        currentQueryString.search = search.searchText !== '' ? search.searchText : undefined;

        const newQueryString = queryString.stringify(currentQueryString);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: '?' + newQueryString
        });
    }

    render() {

        const userSearchForm = <LocalForm
            model="search"
            onSubmit={search =>
                this.updateQuery(search)
            }
            validateOn="submit"
            className="form form-inline col-12 my-2"
        >
            <div className="input-group w-xl-30 w-100">
                <Control.text
                    defaultValue={this.props.queryParams.search}
                    model=".searchText"
                    id="searchText"
                    placeholder=""
                    className="form-control"
                    maxLength={100}
                />
                <div className="input-group-append">
                    <button className="btn btn-primary">Search</button>
                </div>
            </div>
        </LocalForm>;


        const SortUsersChoices: ISortOption[] = [
            { value: UserSortBy.ID, label: 'ID' },
            { value: UserSortBy.APCCODE_CREATEDDATE, label: 'APC Code / Reg. Date' },
            { value: UserSortBy.APCCODE, label: 'APC Code' },
            //{ value: UserSortBy.NAME, label: 'Name' },
            { value: UserSortBy.SURNAME, label: 'Surname' },
            { value: UserSortBy.PROBATIONARY, label: 'Probationary' },
            { value: UserSortBy.CREATEDDATE, label: 'Reg. Date' },
            { value: UserSortBy.POSTCODE, label: 'Post Code' },
            { value: UserSortBy.EMAIL, label: 'Email' },
            { value: UserSortBy.LASTACTIVITY, label: 'Last Login' },
            { value: UserSortBy.LASTSCAN, label: 'Last Scan' },
        ]

        const UsersTable = withSortByQuery(PaginatedTable);

        return (<div className="row m-3">
            <h2>Administration Dashboard</h2>
            {userSearchForm}
            <hr className="w-100" />
            <div className="col-12">
                <UsersTable
                    countPerPage={25}
                    data={this.props.users}
                    dataColumns={[
                        { label: "ID", dataKey: "id" },
                        { 
                            label: "APC Code", 
                            dataKey: "apcCode",
                            className: "d-none d-lg-table-cell",
                            classNameHeader: "d-none d-lg-table-cell", 
                         },
                        {
                            label: "First Name",
                            dataKey: undefined,
                            render: (u: DTOS.User) => <div>{u.fullName} {u.probationary ? <span className="badge badge-info">Probationary</span> : null}</div>
                        },
                        {
                            label: "Surname",
                            dataKey: undefined,
                            render: (u: DTOS.User) => <div>{u.surname}</div>
                        },
                        {
                            label: "Email",
                            dataKey: "email",
                            className: "d-none d-lg-table-cell",
                            classNameHeader: "d-none d-lg-table-cell",
                        },
                        {
                            label: "Post Code",
                            dataKey: "postCode",
                            className: "d-none d-lg-table-cell",
                            classNameHeader: "d-none d-lg-table-cell",
                        },
                        {
                            label: "Reg. Date",
                            dataKey: undefined,
                            render: (u: DTOS.User) => u.createdDate ? moment(u.createdDate).format(this.props.defaultDateFormat) : 'Unknown',
                            className: "d-none d-lg-table-cell",
                            classNameHeader: "d-none d-lg-table-cell", 
                        },
                        {
                            label: "Last Login",
                            dataKey: undefined,
                            render: (u: DTOS.User) => u.lastActivityDate ? moment(u.lastActivityDate).format(this.props.defaultDateFormat) : 'Never',
                            className: "d-none d-lg-table-cell",
                            classNameHeader: "d-none d-lg-table-cell", 
                        },
                        {
                            label: "Last Scan",
                            dataKey: undefined,
                            render: (u: DTOS.User) => u.lastScanDate ? moment(u.lastScanDate).format(this.props.defaultDateFormat) : 'Never',
                            className: "d-none d-lg-table-cell",
                            classNameHeader: "d-none d-lg-table-cell", 
                        },
                        {
                            label: "Edit",
                            dataKey: undefined,
                            render: (u: DTOS.User) => <Link className="text-nowrap" to={`/admin/user/${u.id}`}><i className="btn-primary fa fa-edit p-2"></i></Link>
                        },
                    ]}
                    dataLoading={this.props.usersLoading}
                    dataSortOptions={SortUsersChoices}
                    sort={sortUsers}
                    tableClassName={"table-sm table-bordered table-hover"}
                />
            </div>
        </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageAdminUsersAllProps): PageAdminUsersPropsMapped => {

    return {
        users: state.admin.users,
        usersLoading: state.admin.usersLoading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PageAdminUsersActionsMapped>({
        searchUsers: AdminActionCreators.searchUsersRequest,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PageAdminUsers);